import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import CV from './pages/CV';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import Admin from './pages/Admin';
import AdminProjectForm from './pages/AdminProjectForm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes with Navigation and Footer */}
        <Route path="/" element={<><Navigation /><Home /><Footer /></>} />
        <Route path="/projects" element={<><Navigation /><Projects /><Footer /></>} />
        <Route path="/projects/:id" element={<><Navigation /><ProjectDetail /><Footer /></>} />
        <Route path="/cv" element={<><Navigation /><CV /><Footer /></>} />
        <Route path="/contact" element={<><Navigation /><Contact /><Footer /></>} />
        
        {/* Admin Routes (no navigation/footer) */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/project/new" element={<AdminProjectForm />} />
        <Route path="/admin/project/edit/:id" element={<AdminProjectForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
